module.exports = __webpack_public_path__ + "img/ccompany-honor-RoHS-20241212.867f27e6.jpg";